import type { DashboardData } from "./dashboardData"
import { StageSection } from "./StageSection"

type DashboardProps = {
  data: DashboardData
}

export function Dashboard({ data }: DashboardProps) {
  return (
    <div className="flex flex-col gap-6">
      {data.stage_sections.map((section) => (
        <StageSection dashboardDate={data.dashboard_date} key={section.title} section={section} />
      ))}
    </div>
  )
}
